type IframeManagerState = { acceptedServices: string[] };
type IframeManager = {
    getState?: () => IframeManagerState;
    acceptService?: (service: string) => void;
};

const getIframeManager = (): IframeManager | null => {
    const fn = (window as unknown as { iframemanager?: () => IframeManager }).iframemanager;
    if (typeof fn !== 'function') return null;
    try { return fn(); } catch { return null; }
};

const isYoutubeAccepted = (): boolean => {
    const im = getIframeManager();
    try { return im?.getState?.()?.acceptedServices?.includes('youtube') ?? false; } catch { return false; }
};

const acceptYoutube = (): void => {
    getIframeManager()?.acceptService?.('youtube');
};

const buildEmbedUrl = (videoId: string, time: string): string =>
    `https://www.youtube.com/embed/${videoId}?autoplay=1&start=${time}&rel=0`;

export const initYoutubePopup = (): void => {
    const popup = document.getElementById('yt-popup');
    const iframe = document.getElementById('yt-popup-iframe') as HTMLIFrameElement | null;
    const closeBtn = document.getElementById('yt-popup-close');
    const consentBlock = document.getElementById('yt-popup-consent');
    const consentAcceptBtn = document.getElementById('yt-popup-consent-accept');
    if (!popup || !iframe || !closeBtn || !consentBlock || !consentAcceptBtn) return;

    let pendingVideoId: string | null = null;
    let pendingTime: string = '0';

    const showPopup = (): void => {
        popup.classList.remove('hidden');
        popup.classList.add('flex');
    };

    const hidePopup = (): void => {
        popup.classList.add('hidden');
        popup.classList.remove('flex');
        iframe.src = '';
        iframe.classList.add('hidden');
        consentBlock.classList.add('hidden');
        consentBlock.classList.remove('flex');
        consentBlock.style.backgroundImage = '';
        pendingVideoId = null;
        pendingTime = '0';
    };

    const loadVideo = (videoId: string, time: string): void => {
        iframe.src = buildEmbedUrl(videoId, time);
        iframe.classList.remove('hidden');
        consentBlock.classList.remove('flex');
        consentBlock.classList.add('hidden');
    };

    const showConsent = (videoId: string): void => {
        iframe.classList.add('hidden');
        iframe.src = '';
        consentBlock.style.backgroundImage = `url('https://img.youtube.com/vi/${videoId}/maxresdefault.jpg')`;
        consentBlock.classList.remove('hidden');
        consentBlock.classList.add('flex');
    };

    document.querySelectorAll<HTMLElement>('[data-yt-video]').forEach((trigger) => {
        trigger.addEventListener('click', (e: Event) => {
            e.preventDefault();
            const el = e.currentTarget as HTMLElement;
            const videoId = el.dataset.ytVideo;
            const time = el.dataset.ytTime || '0';
            if (!videoId) return;

            pendingVideoId = videoId;
            pendingTime = time;
            showPopup();

            if (isYoutubeAccepted()) {
                loadVideo(videoId, time);
            } else {
                showConsent(videoId);
            }
        });
    });

    consentAcceptBtn.addEventListener('click', () => {
        acceptYoutube();
        if (pendingVideoId) loadVideo(pendingVideoId, pendingTime);
    });

    closeBtn.addEventListener('click', hidePopup);
    popup.addEventListener('click', (e: MouseEvent) => {
        if (e.target === popup) hidePopup();
    });
    document.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Escape' && !popup.classList.contains('hidden')) hidePopup();
    });
};
